import React from 'react';

const Testimonials = () => {
  return (
    <section className="section testi-sec-six pb-0">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div>
                        <img src="assets/img/section-img-03.png" alt="Hình ảnh đánh giá"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="testi-info-six">
                        <div className="section-header-six mb-4">
                            <span className="badge badge-soft-primary rounded-pill mb-1">Đánh giá từ khách hàng</span>
                            <h2>Khách hàng nói gì về chúng tôi</h2>
                        </div>
                        <div>
                            <div className="d-flex align-items-center fs-12 mb-4">
                                <i className="ti ti-star-filled text-primary"></i>
                                <i className="ti ti-star-filled text-primary"></i>
                                <i className="ti ti-star-filled text-primary"></i>
                                <i className="ti ti-star-filled text-primary"></i>
                                <i className="ti ti-star-filled  text-primary me-1"></i>
                                <p className="fs-14 text-gray-9">5.0</p>
                            </div>
                            <p className="mb-4 testi-para">
                                Tôi vừa đặt tour du lịch thông qua website này và thực sự hài lòng với trải nghiệm. 
                                Quá trình đặt tour rất dễ dàng và nhanh chóng. Tuy nhiên, tôi mong muốn có thêm 
                                thông tin chi tiết hơn về các chi phí bổ sung trong quá trình đặt tour.
                            </p>
                            <div className="bg-white rounded-pill p-3 d-inline-flex align-items-center">
                                <a href="#" className="avatar avtar-lg me-2">
                                    <img src="assets/img/users/user-28.jpg" className="rounded-circle" alt="Ảnh đại diện"/>
                                </a>
                                <div>
                                    <h6><a href="#">Rachel Mariscal</a></h6>
                                    <span className="d-block">Hoa Kỳ</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="client-logos-sec">
            <div className="container">
                <div>
                    <h6 className="text-white mb-3">Hơn 40+ đối tác trên toàn thế giới</h6>
                </div>
                <div className="owl-carousel client-slider d-flex justify-content-between align-items-center">
                    <div className="client-img">
                        <img src="assets/img/clients/client-01.svg" className="img-white" alt="Đối tác"/>
                    </div>
                    <div className="client-img">
                        <img src="assets/img/clients/client-02.svg" className="img-white" alt="Đối tác"/>
                    </div>
                    <div className="client-img">
                        <img src="assets/img/clients/client-03.svg" className="img-white" alt="Đối tác"/>
                    </div>
                    <div className="client-img">
                        <img src="assets/img/clients/client-04.svg" className="img-white" alt="Đối tác"/>
                    </div>
                    <div className="client-img">
                        <img src="assets/img/clients/client-05.svg" className="img-white" alt="Đối tác"/>
                    </div>
                    <div className="client-img">
                        <img src="assets/img/clients/client-06.svg" className="img-white" alt="Đối tác"/>
                    </div>
                    <div className="client-img">
                        <img src="assets/img/clients/client-07.svg" className="img-white" alt="Đối tác"/>
                    </div>
                    <div className="client-img">
                        <img src="assets/img/clients/client-04.svg" className="img-white" alt="Đối tác"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Testimonials;
